module.exports = __webpack_public_path__ + "02_short_black.7c87b1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_short_black.png
// module id = ZJtw
// module chunks = 0